<template>
  <div>
    <section>
      <header1></header1>
    </section>
    <section>

      <div class="contents">

        <div else class="photocentent">
          <van-form @submit="onSubmit">
            <div class="s">
              <input class="input" placeholder="7000万人都在看" v-model="searchValue">
              <div class="sbtn" native-type="submit">搜索</div>
            </div>
          </van-form>
          <div class="send">
            搜索"{{ searchValue }}"的结果
          </div>
          <div class="search_list">
            <section class="newsList" v-if="!loading">
              <router-link :to="{name:'detail',params:{id:v.id}}" class="news-item" style="padding-top:0.4rem" v-for="(v,k) in newList" :key="k">
                <div class="right-content" style="width: 100%">
                  <div class="subject" v-html="v.title"></div>
                </div>
              </router-link>
            </section>
            <div v-if="loading" class="Pageloading">
              <van-loading size="24" color="#007aff"/>
            </div>
          </div>
        </div>
      </div>


    </section>
    <footer1></footer1>
  </div>
</template>

<script>
import header1 from '@/components/header4';
import footer1 from '@/components/footer';
import {getList} from "../commJs/api";

export default {
  data() {
    return {
      loading: true,
      searchValue: "",
      newList: [],
      page: 1,

    }
  },
  watch: {
    '$route': function () {
      this.loading = true
      this.newList = '';
      let keys = this.$route.params.keys
      this.searchValue = keys
      this.getSearch(keys)
    }
  },
  components: {
    header1,
    footer1,
  },
  methods: {
    getIndex() {

    },
    onSubmit() {
      this.$router.push({name:'/search',params:{keys:this.searchValue}});
    },
    getSearch(k) {
      getList({key: k, count: 20, page: parseInt(this.page)}).then(res => {
        if (res.code == 200) {
          this.loading = false
          this.newList = res.data.newsList;
        }
      })
    },
  },
  mounted() {
    let keys = this.$route.params.keys
    this.searchValue = keys
    this.getSearch(keys)
  }
}
</script>

<style scoped lang="less">
.contents {
  min-height: 60vh;
}

.photocentent {
  padding: 10px;
}

.photocentent .s {
  margin-top: 10px;
  display: flex;
}

.photocentent .input {
  font-size: 14px;
  width: calc(100% - 100px);
  border: 1px solid #ddd;
  height: 35px;
  line-height: 35px;
  padding: 0 5px;
  color: #444;
}

.photocentent .sbtn {
  background: #4b555f;
  color: #fff;
  width: 90px;
  height: 37px;
  font-size: 16px;
  text-align: center;
  line-height: 37px;
}

.send {
  font-size: 14px;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.search_list {
  .subject span {
    color: red
  }
}
</style>